import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { Alert } from 'projects/shared/models/alert.model';
import { AlertType } from 'projects/shared/models/alert-type.enum';
import { take } from 'rxjs/operators';

@Component({
    selector: 'sso-login',
    templateUrl: 'sso-login.component.html',
    standalone: false
})
export class SsoLoginComponent implements OnInit {

  protected alert: Alert;

  protected isLoading: boolean = true;

  private _samlRequestId: string;
  private _relayState: string;
  private _assertionConsumerServiceUrl: string;

  constructor(
    private readonly _activatedRoute: ActivatedRoute,
    private readonly _authService: AuthService,
  ) {}

  ngOnInit() {
    this._activatedRoute.queryParamMap.pipe(take(1)).subscribe((params) => {
      // Example params: ?id=...&acs=...&state=...
      this._samlRequestId = params.get('id');
      this._relayState = params.get('state');
      this._assertionConsumerServiceUrl = params.get('acs');

      const authCompletionToken = this.getCookieValue('sso_auth_completion_token');
      if (authCompletionToken) {
        this.deleteCookie('sso_auth_completion_token');
        this._authService.postSsoCompleted(
          this._samlRequestId,
          this._relayState,
          this._assertionConsumerServiceUrl,
          authCompletionToken,
        ).subscribe({
          next: (response) => {
            if (response) {
              document.open();
              document.write(response);
              document.close();
            } else {
              this.isLoading = false;
              this.alert = {
                type: AlertType.Error,
                title: 'Error',
                message: 'There was an error processing your request. Please try again.',
              }
            }
          },
          error: () => {
            this.isLoading = false;
            this.alert = {
              type: AlertType.Error,
              title: 'Error',
              message: 'There was an error processing your request. Please try again.',
            }
          }
        });
      } else {
        this.isLoading = false;
        this.alert = {
          type: AlertType.Error,
          title: 'Error',
          message: 'Authentication token not found. This usually happens when your browser blocks pop-up windows. Please allow pop-ups for this site and try again.',
        }
      }
    });
  }

  private getCookieValue(name: string): string | null {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  private deleteCookie(name: string): void {
    document.cookie = `${name}=; path=/; max-age=0; secure; SameSite=None`;
  }
}
